import { CoralogixRum } from "@coralogix/browser";

import { isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

/**
 * Coralogix initialization for the client
 */
const clientInitCoralogix = () => {
  if (isProduction()) {
    CoralogixRum.init({
      public_key: "cxtp_EqgIywKtCY3hfp6bhwlek1bjFN0w5s",
      application: "hw-admin",
      version: window.ENV.CI_COMMIT_SHA || "local",
      coralogixDomain: "US1",
    });
  }
};

export { clientInitCoralogix };
